import { type DocumentNode, gql } from '@apollo/client';

const tokenExchange: DocumentNode = gql`
  mutation tokenExchange($tokenProvider: String!, $params: JSONString!) {
    tokenExchange(tokenProvider: $tokenProvider, params: $params) {
      token
      refreshExpiresIn
      payload
    }
  }
`;

export default tokenExchange;
